import {burocrazia, economia, manutenzione, vitalavoro} from '@/assets/'

export const services = [
  {
    title: 'Gestione economica',
    id: "economia",
    image: economia,
    description:
      'Ti aiuto a migliorare la gestione del tuo denaro con strumenti semplici e strategie pratiche per avere controllo e serenità.',
    topics: [
      {
        title: 'Analisi delle spese',
        content: 'Ti aiuto a capire dove vanno i tuoi soldi e come individuare margini di risparmio realistici.',
      },      
      {
        title: 'Investimenti',
        content: 'Ti spiego i concetti base e ti aiuto a capire come orientarti tra le opzioni disponibili, senza promuovere prodotti specifici.',
      },
      {
        title: 'Strumenti utili',
        content: 'Ti mostro app e metodi per semplificare la gestione quotidiana del denaro, anche se non sei esperto.',
      },
    ],
  },
  {
    title: 'Burocrazia e tasse',
    id: "burocrazia",
    image: burocrazia,
    description:
      'Ti aiuto a gestire con chiarezza bollette, documenti e bonus, così da non sentirti più sopraffatto dalla burocrazia.',
    topics: [
      {
        title: 'Scadenze e bollette',
        content: 'Ti mostro come organizzare le scadenze per non dimenticarle e automatizzare dove possibile.',
      },
      {
        title: 'Bonus e agevolazioni',
        content: 'Ti aiuto a individuare i bonus a cui hai diritto e a richiederli correttamente.',
      },
      {
        title: 'Gestione documenti',
        content: 'Impostiamo insieme un sistema semplice per conservare e ritrovare rapidamente i tuoi documenti.',
      },
    ],
  },
  {
    title: 'Vita e lavoro',
    id: "vitalavoro",
    image: vitalavoro,
    description:
      'Ti aiuto a trovare un equilibrio tra vita personale e lavoro, affrontando momenti di cambiamento e organizzazione.',
    topics: [
      {
        title: 'Gestione del tempo',
        content: 'Lavoriamo su come usare meglio il tuo tempo e ridurre la sensazione di essere sempre di corsa.',
      },
      {
        title: 'Cambiamento lavorativo',
        content: 'Se stai cercando una nuova strada o vuoi migliorare la tua situazione attuale, ti affianco nel chiarire i tuoi obiettivi.',
      },
      {
        title: 'Routine e benessere',
        content: 'Definiamo insieme piccole abitudini sostenibili per migliorare la tua energia quotidiana.',
      },
    ],
  },
  {
    title: 'Manutenzione casa e auto',
    id: "manutenzione",
    image: manutenzione,
    description:
      'Ti fornisco istruzioni pratiche e soluzioni semplici per affrontare imprevisti e gestione ordinaria.',
    topics: [
      {
        title: 'Manutenzione ordinaria',
        content: 'Ti aiuto a capire cosa fare periodicamente per tenere in ordine casa e auto con poco sforzo.',
      },
      {
        title: 'Quando chiamare un tecnico',
        content: 'Ti spiego come valutare se puoi intervenire da solo o se è meglio chiamare un professionista.',
      },
      {
        title: 'Check e scadenze',
        content: 'Ti fornisco un sistema semplice per tenere sotto controllo assicurazioni, revisioni e altre scadenze.',
      },
    ],
  },
];